// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3CW3z","container":"styles_container__G3UfZ","title":"styles_title__3y_ay","wrapper":"styles_wrapper__2JyAN","answer":"styles_answer__3cDkE"};